import { render } from "./RouteNotFoundComponent.vue?vue&type=template&id=852628b0&ts=true"
import script from "./RouteNotFoundComponent.vue?vue&type=script&lang=ts"
export * from "./RouteNotFoundComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__